import React from 'react';

const AdminHomePage: React.FC = () => <div />;

export default AdminHomePage;
